var render = function render() {
  var _vm = this,
      _c = _vm._self._c,
      _setup = _vm._self._setupProxy;return _c('div', [_c('el-button', _vm._b({ staticClass: "download-model-btn", on: { "click": _vm.download } }, 'el-button', _vm.buttonAttrs, false), [_vm._v(_vm._s(_vm.$t('playTurbo.custom.downloadModel')))])], 1);
};
var staticRenderFns = [];

export { render, staticRenderFns };